import { getIsGoodRoad, goodRoadsSliceActions } from '@/modules/goodRoad/slice';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { hostsSliceActions } from '../../../modules/host/slice';
import { CMDScGameRest, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScGameRestHandler extends AbstractHandler {
    _command: CMDScGameRest;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScGameRest;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const goodRoad = getIsGoodRoad(state, this._command.HostID);
        dispatch(
            hostLiveSliceActions.updateGameRest({
                hostId: this._command.HostID,
                onOrOff: this._command.OnOrOff,
                isTest: IsInternalTest,
            })
        );
        dispatch(
            hostsSliceActions.updateGameRest({
                hostId: this._command.HostID,
                onOrOff: this._command.OnOrOff,
                isTest: IsInternalTest,
            })
        );

        if (goodRoad) {
            dispatch(
                goodRoadsSliceActions.update({
                    HostId: this._command.HostID,
                    isGoodRoad: goodRoad.isGoodRoad,
                    isRest: getIsRestState(
                        this._command.OnOrOff,
                        IsInternalTest
                    ).isRest,
                })
            );
        }
    }
}
